import { STATE } from '../constants/stateClasses';
import { breakpoints } from '../utils/breakpoints';
import { lightbox } from './handleGlightbox';
import { scroll } from './locomotive';

const selectors = {
  gallery: '.js-gallery',
  galleryWrapepr: '.js-gallery-wrapper',
  item: '.js-gallery-item',
  menu: '.js-gallery-menu',
  menuBtn: '.js-gallery-menu-btn',
  menuBtnText: '.js-gallery-menu-btn-text',
  menuList: '.js-gallery-menu-list',
  btn: '.js-gallery-btn',
  sizer: '.js-gallery-sizer',
};

const loadShuffle = async () => {
  const { default: Shuffle } = await import('shufflejs');

  return Shuffle;
};

const removeClassNames = (array) => {
  array.forEach((item) => item.classList.remove(STATE.active));
};

const handleMenuBtnClick = (e, menuList) => {
  const { currentTarget } = e;

  currentTarget.classList.toggle(STATE.active);
  menuList.classList.toggle(STATE.active);
};

const changeGalleryID = (items, btn) => {
  if (!items.length) return;

  items.forEach((item) => {
    // Change gallery ID only for visible items
    if (item.isVisible) {
      const { element } = item;

      // set gallery ID based on clicked category button
      element.dataset.gallery = btn.dataset.gallery;
    }
  });

  // Refresh lightbox
  lightbox?.reload();
};

const closeMenuListener = ({ menuBtn, menuList }) => {
  document.addEventListener('click', (e) => {
    const { target } = e;

    if (target.closest(selectors.menu)) return;

    menuBtn.classList.remove(STATE.active);
    menuList.classList.remove(STATE.active);
  });
};

const handleShuffle = async () => {
  let isInitLayout = true;
  let isGalleryVisible = false;

  const galleryWrapper = document.querySelector(selectors.galleryWrapepr);

  if (!galleryWrapper) return;

  const gallery = galleryWrapper.querySelector(selectors.gallery);
  const btns = document.querySelectorAll(selectors.btn);
  const menuBtn = document.querySelector(selectors.menuBtn);
  const menuBtnText = menuBtn?.querySelector(selectors.menuBtnText);
  const menuList = document.querySelector(selectors.menuList);

  closeMenuListener({ menuBtn, menuList });

  let shuffleInstance;

  try {
    const Shuffle = await loadShuffle();

    Shuffle.ShuffleItem.Scale.HIDDEN = 0.7;

    // Init Shuffle
    shuffleInstance = new Shuffle(gallery, {
      itemSelector: selectors.item,
      sizer: selectors.sizer,
      delimiter: ',',
      easing: 'ease',
      speed: 300,
      gutterWidth: () => {
        const windowWidth = window.innerWidth;

        if (windowWidth < breakpoints.mobile) return 0;

        return windowWidth * 0.03125;
      },
    });

    // Handle filtering by category
    if (btns.length) {
      const handleClick = (e) => {
        const btn = e.currentTarget;

        if (btn.classList.contains(STATE.active)) return;

        // Update menu btn text
        menuBtnText.textContent = btn.textContent;

        // Hide list
        menuList.classList.remove(STATE.active);

        // Filter items
        shuffleInstance.filter(btn.dataset.group);

        // Set lightbox gallery items correct ID
        changeGalleryID(shuffleInstance.items, btn);

        // Handle btn appearance
        removeClassNames(btns);
        btn.classList.add(STATE.active);
      };

      btns.forEach((btn) => btn.addEventListener('click', handleClick));
      menuBtn.addEventListener('click', (e) => handleMenuBtnClick(e, menuList));

      shuffleInstance?.on(Shuffle.EventType.LAYOUT, () => {
        if (isInitLayout) {
          // Change category on init
          shuffleInstance.filter(menuList.dataset.group);
          // Set lightbox gallery items correct ID
          changeGalleryID(shuffleInstance.items, btns[1]);

          isInitLayout = false;
        }

        if (!isInitLayout && !isGalleryVisible) {
          setTimeout(() => {
            galleryWrapper.classList.add(STATE.inView);
            isGalleryVisible = true;
          }, shuffleInstance.options.speed);
        }

        scroll.update();
      });
    }
  } catch (error) {
    console.log(error);
  }

  return shuffleInstance;
};

export default handleShuffle;
